<script setup lang="ts">
import {computed} from "vue";
import {getEnv} from "@/utilities/env";

const props = defineProps<{
  flag: string;
  size?: number;
}>();

const url = getEnv('VITE_NF_BASE_PATH') + 'img/flags';

const size = computed(() => props.size ?? 24);

const svg = computed(() => `${url}/${props.flag}.svg`);

</script>

<template>
  <img :src="svg"
       :height="size"
       :alt="props.flag"/>
</template>